import { AudienceOption } from '@openx/types/targeting/audience';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useAudienceTitles = () => {
  const { t } = useTranslation();

  const titles = useMemo(
    () => ({
      [AudienceOption.DMP_SEGMENTS]: t('3rd Party DMP'),
      [AudienceOption.INTENDED_AUDIENCE]: t('Intended Audience'),
      [AudienceOption.LIVEINTENT]: t('LiveIntent'),
      [AudienceOption.MATCHED_USERS]: t('Matched Users'),
      [AudienceOption.OPEN_AUDIENCES]: t('OpenXSelect'),
      [AudienceOption.TRAFFIC_FILTER_EIDS]: t('Matched Users'),
    }),
    [t]
  );

  return { titles };
};
